/** عرض مرئي للهيرو — لقطة موقع كاملة بدون قص */
export default function HeroVisual() {
  return (
    <div className="relative max-w-md mx-auto w-full">
      <div className="absolute -inset-4 rounded-3xl bg-gradient-to-br from-teal-500/25 to-cyan-500/10 blur-2xl animate-glow-pulse" />

      <div className="relative v2-glass-card p-3 rounded-3xl rotate-3 hover:rotate-0 transition-transform duration-700 overflow-hidden">
        <div className="rounded-2xl overflow-hidden bg-gradient-to-br from-slate-900 via-[#0c1222] to-teal-950 border border-white/5">
          <div className="flex items-center gap-2 px-3 py-2.5 border-b border-white/10 bg-black/50 shrink-0">
            <span className="w-2.5 h-2.5 rounded-full bg-red-400/90" />
            <span className="w-2.5 h-2.5 rounded-full bg-amber-400/90" />
            <span className="w-2.5 h-2.5 rounded-full bg-emerald-400/90" />
            <div className="flex-1 h-6 mx-1 rounded-md bg-white/5 border border-white/5" />
          </div>

          <img
            src="/images/surfing-hero.png"
            alt="نموذج موقع — الاتحاد السعودي لركوب الأمواج"
            className="block w-full h-auto"
            width={1024}
            height={559}
            loading="eager"
          />
        </div>
      </div>

      <div className="absolute -bottom-4 -right-4 z-10 v2-glass-card px-5 py-3 rounded-2xl border-teal-400/20 shadow-lg">
        <div className="text-2xl font-extrabold v2-gradient-text">+3500</div>
        <div className="text-xs text-slate-400">عميل راضٍ</div>
      </div>
      <div className="absolute -top-2 -left-2 z-10 v2-glass-card px-4 py-2 rounded-xl text-sm text-teal-300 font-semibold border-teal-400/20">
        <i className="ri-flashlight-line ml-1" />
        سرعة فائقة
      </div>
    </div>
  );
}
